import { usePagination, useSearch, useSorting } from "@/hooks";
import { GetRatingsParams } from "@/redux/apis/rating/types";

export const useGetRatingsParams = () => {
  const [search, setSearch] = useSearch();
  const { page, pageSize } = usePagination();
  const { sortKey, direction } = useSorting();

  const params: GetRatingsParams = {
    page,
    page_size: pageSize,
    sort: sortKey,
    direction,
    search,
  };

  return { params, page, pageSize, sort: sortKey, direction, search, setSearch };
};
